import { styled } from "@mui/material/styles";
import { DatePicker } from "@mui/x-date-pickers";
import { colors } from "../../../theme/theme";

export const StyledDatePicker = styled(DatePicker, {
  shouldForwardProp: (prop) => prop !== "$width",
})(({ $width, theme }) => ({
  backgroundColor: "transparent",
  fontFamily: "'Quicksand', sans-serif",
  fontSize: "114px",
  fontWeight: "400",
  color: colors.primary,
  borderRadius: "14px",
  width: $width || "100%",
  marginTop: "auto",
  minWidth: 200,
  boxShadow:
    "-4px -4px 17.8px 0px rgba(205, 214, 223, 0.15), 4px 4px 15px 0px rgba(205, 214, 223, 0.25)",
  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: "14px",
    border: "none",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "1px solid rgba(73, 42, 24, 0.2)",
  },
  "& .MuiOutlinedInput-input": {
    height: "23px",
    color: colors.primary,
  },
  ".MuiSvgIcon-root": {
    fill: `${colors.primary} !important`,
  },
  [theme.breakpoints.down("md")]: {
    ".MuiOutlinedInput-input": {
      fontSize: "14px",
    },
  },
  [theme.breakpoints.down("sm")]: {
    minWidth: 100,
    width: "100%",
    ".MuiOutlinedInput-input": {
      fontSize: "12px",
    },
    ".MuiSvgIcon-root": {
      width: 20,
      height: 20,
    },
  },
}));
